export default "__VITE_ASSET__BgQVHaSr__"